import { properties } from "../../utils/Properties_es";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  styled,
  FormHelperText,
} from "@mui/material";
import { useApp } from "../../hooks/useApp";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { ContentEndUser } from "../../types/EndUser";

const Title = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: "#e1e8ee",
  color: "#3e627c!important",
  fontFamily: "D-dinExp",
  fontWeight: 400,
  fontSize: "17.5px",
}));
const Text = styled(DialogContentText)(({ theme }) => ({
  color: theme.palette.greyDue.light,
  fontFamily: "D-dinExp",
  fontWeight: 400,
  textAlign: "center",
  fontSize: "17px",
  padding: theme.spacing(4),
}));
const Actions = styled(DialogActions)(({ theme }) => ({
  borderTop: "1px solid #dee2e6",
}));

interface AddOrUpdateEndUser {
  id?: number;
  user: string;
  mail: string;
  phoneNumber: string;
  lastName: string;
  name: string;
}

interface DialogProps {
  actionButton?: any;
  data: ContentEndUser;
  onSubmit: any;
  cancelModal: any;
  modalType?: any;
}

const AddOrUpdateEndUsersModal = ({
  data,
  onSubmit,
  cancelModal,
}: DialogProps) => {

  //Validación de datos
  const validation = Yup.object().shape({
    lastName: Yup.string().required("Campo es requerido"),
    name: Yup.string().required("Campo es requerido"),
    user: Yup.string().required("Campo es requerido"),
    mail: Yup.string().required("Campo es requerido").email("Correo electrónico inválido"),
    phoneNumber: Yup.string().required("Campo es requerido"),

  });

  const defaultValues = {
    id: data.id ? data.id : 0,
    lastName: data.lastName ? data.lastName : "",
    name: data.name ? data.name : "",
    user: data.user ? data.user : "",
    mail: data.mail ? data.mail : "",
    phoneNumber: data.phoneNumber ? data.phoneNumber : "",

  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<AddOrUpdateEndUser>({
    defaultValues,
    resolver: yupResolver(validation),
    mode: "onChange",
  });

  return (
    <>
      <Title id="alert-dialog-title" sx={{ pt: 4, px: 4 }}>
        {data.id ? properties.com_parval_label_button_edit_enduser : properties.com_parval_label_button_add_enduser}
      </Title>
      <DialogContent sx={{ px: 4, pb: 0 }}>
        <form>
          <Grid container spacing={3} maxWidth="lg" sx={{ pt: 4, pb: 8 }}>
            <Grid item xs={12}>
              <Controller
                name={"name"}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    fullWidth
                    size="small"
                    label="Nombre"
                    type="text"
                    variant="standard"
                    value={value}
                    autoComplete="name3"
                    sx={{ "& input": { pl: "0!important" } }}
                    {...register("name")}
                    error={errors.name && Boolean(errors.name)}
                    helperText={errors.name && errors.name.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name={"lastName"}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    fullWidth
                    size="small"
                    label="Apellido"
                    type="text"
                    variant="standard"
                    value={value}
                    autoComplete="lastName"
                    sx={{ "& input": { pl: "0!important" } }}
                    {...register("lastName")}
                    error={errors.lastName && Boolean(errors.lastName)}
                    helperText={
                      errors.lastName && errors.lastName.message
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name={"user"}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    fullWidth
                    size="small"
                    label="Usuario"
                    type="text"
                    variant="standard"
                    value={value}
                    autoComplete="user"
                    sx={{ "& input": { pl: "0!important" } }}
                    {...register("user")}
                    error={errors.user && Boolean(errors.user)}
                    helperText={
                      errors.user && errors.user.message
                    }
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name={"mail"}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    fullWidth
                    size="small"
                    label="Correo electrónico"
                    type="email"
                    variant="standard"
                    value={value}
                    autoComplete="mail"
                    sx={{ "& input": { pl: "0!important" } }}
                    {...register("mail")}
                    error={errors.mail && Boolean(errors.mail)}
                    helperText={
                      errors.mail && errors.mail.message
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name={"phoneNumber"}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    fullWidth
                    size="small"
                    label="Número de teléfono"
                    type="text"
                    variant="standard"
                    value={value}
                    autoComplete="phoneNumber"
                    sx={{ "& input": { pl: "0!important" } }}
                    {...register("phoneNumber")}
                    error={errors.phoneNumber && Boolean(errors.phoneNumber)}
                    helperText={
                      errors.phoneNumber && errors.phoneNumber.message
                    }
                  />
                )}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <Actions sx={{ pb: 4, px: 4 }}>
        <Button
          variant="contained"
          color="primary"
          sx={{
            mt: 2,
            mr: 2,
          }}
          onClick={handleSubmit(onSubmit)}
        >
          Aceptar
        </Button>
        <Button
          variant="contained"
          color="secondary"
          sx={{
            mt: 2,
            mr: 2,
          }}
          onClick={cancelModal}
          autoFocus
        >
          Cancelar
        </Button>{" "}
      </Actions>
    </>
  );
};

export default AddOrUpdateEndUsersModal;
